export default __webpack_public_path__ + "static/media/icon 11.763ff138.svg";